import React from 'react';
import { Button } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const MessageDialog = ({ message, isClose }) => {
  // const { message} = responseObj && responseObj;
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      BULK_FILE_UPLOAD: { CLOSE }
    }
  } = localizedStrings;
  return (
    <>
      <div id="overlay-layer">
        <div id="overlay-story">
          <div>
            <span>{message}</span>
          </div>
          {/* <div style={{ marginTop: 20 }}>
                <h1>{BULK_FILE_USER} : {bulkUsers.length}</h1>
                <h1>{REGISTER_USER}: {registeredUsers.length}</h1>
                <h1>{REJECTED_USER}: {rejectedUsers.length}</h1>
                {rejectedUsers && rejectedUsers.length > 0 && <Table rejectedUsers={rejectedUsers} /> }    
              </div> */}
          <Button variant={{ priority: 'high' }} type="button"
            style={{ marginTop: '15px' }}
            
            onClick={() => isClose()}
          >
            {CLOSE}
          </Button>
        </div>
      </div>
    </>
  );
};

MessageDialog.propTypes = {
  message: PropTypes.string.isRequired,
  isClose: PropTypes.func.isRequired
};
export default MessageDialog;
